import React from 'react';
import SVG from 'react-inlinesvg';
import { Container } from 'styles';
import {
  StyledList,
  StyledLegacyListItem,
} from './multipart-description.style';

interface Part {
  description: React.ReactNode;
  icon: string;
  id: number | string;
}

interface Props extends StyleProps {
  parts: Part[];
}

export const MultipartDescription = (props: Props) => (
  <StyledList {...props}>
    {props.parts.map(part => (
      <StyledLegacyListItem key={part.id}>
        <Container>
          <SVG height="48px" width="48px" src={part.icon} aria-hidden="true" />
        </Container>
        {part.description}
      </StyledLegacyListItem>
    ))}
  </StyledList>
);
